export default __webpack_public_path__ + "static/media/icon-status-incomplete.27d72018.svg";